import React, { useState, useEffect, useRef } from 'react';
import { billing, clients, one, two, oneright, twoleft, mentalhealth, fiirst, second, third, fourth, accounts, dental, consulting, emr, finacess, severices, flatlayImg, doctorImg, workright, arrowbg, external1 } from '../../../assets/images';
import { FiArrowDownRight } from 'react-icons/fi';
import { Accordion, Col, Container, Row, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../../config/api';
import { Link } from 'react-router-dom';
import PopularArticles from './PopularArticles';

const AccountsReceivable = () => {
  const sectionRefs = useRef([]);
  const [animatedSections, setAnimatedSections] = useState(new Set());
  const [hasAnimated, setHasAnimated] = useState(new Set());

  // Event tracking function
  const trackEvent = (action, category, label, location) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        custom_parameter_1: location
      });
    }
  };

  // Event handlers
  const handleServiceClick = (serviceName) => {
    trackEvent('click', 'Accounts Receivable Services', serviceName, 'services_section');
  };

  const handleCTAClick = (location) => {
    trackEvent('click', 'Accounts Receivable CTA', 'Lets Connect', location);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.sectionIndex;
          if (index) {
            const sectionIndex = parseInt(index);
            if (entry.isIntersecting && !hasAnimated.has(sectionIndex)) {
              setAnimatedSections(prev => new Set([...prev, sectionIndex]));
              setHasAnimated(prev => new Set([...prev, sectionIndex]));
            }
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setIsSubmitted(false);
  };
  const handleShow = () => setShowModal(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(getContactApiUrl(), {
        fullName: data.fullName,
        email: data.email,
        subject: data.subject,
        message: data.message,
      });
      if (response.data.success) {
        setIsSubmitted(true);
        reset();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const [activeKey2, setActiveKey2] = useState("0");
  const toggleKey2 = (key) => {
    setActiveKey2(activeKey2 === key ? null : key);
  };
  const services = [
    {
      icon: fiirst,
      alt: "Mobile App Development",
      title: "Faster Reimbursements ",
      description:
        "We ensure timely payments through accurate claim submission, active tracking, and consistent follow-up, reducing delays and improving cash flow. ",
    },
    {
      icon: second,
      alt: "Software Development",
      title: "Proactive Denial Resolution ",
      description:
        "Our team identifies the causes of denials, submits prompt appeals, and implements preventive measures to protect your revenue. ",
    },
    {
      icon: third,
      alt: "Digital Transformation",
      title: "Stronger Revenue Cycle ",
      description:
        "By optimizing workflows and resolving issues quickly, we maintain a smooth, efficient revenue cycle that supports long-term financial health. ",
    },

    {
      icon: fourth,
      alt: "IT Consulting",
      title: "Tailored AR Strategies ",
      description:
        "We design AR processes that fit your specific operations, ensuring better collections, compliance, and growth.",
    },
  ];
  const familyMedicineServices = [
    {
      title: "Accounts Receivable",
      description:
        "Enhance cash flow with expert support in efficiently managing and optimizing your accounts receivable process.",
      icon: accounts, // Replace with actual icon path
      alt: "Accounts Receivable Icon"
    },
    {
      title: "Collections & Denial Management",
      description:
        "Recover lost revenue and minimize write-offs through specialized denial management and overdue claims resolution. ",
      icon: dental,
      alt: "Collections & Denial Icon"
    },
    {
      title: "Consulting ",
      description:
        "Collaborate with NP-focused RCM experts to identify inefficiencies, optimize workflows, and maximize revenue potential. ",
      icon: consulting,
      alt: "Consulting Icon"
    },
    {
      title: "EMR & System Integration ",
      description:
        "Create a seamless digital environment with our tech integration specialists improving productivity and ensuring data accuracy. ",
      icon: emr,
      alt: "EHR Integration Icon"
    },
    {
      title: "Financial Analysis & Reporting ",
      description:
        "Gain complete financial visibility with data-driven insights, advanced analytics, and easy-to-understand reporting.",
      icon: finacess,
      alt: "Financial Analysis Icon"
    },
    {
      title: "Medical Billing Services ",
      description:
        "Boost reimbursements with personalized, technology-driven billing solutions designed specifically for Nurse Practitioners. ",
      icon: severices,
      alt: "Medical Billing Icon"
    }
  ];
  return (
    <>
      <style>{`
        @media (min-width: 768px) {
       
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateX(-40px) rotateY(5deg);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1 !important;
            transform: translateX(0) rotateY(0deg) !important;
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(60px) scale(0.9);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(70px) scale(0.92);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(55px) scale(0.96);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateX(35px) rotateY(-3deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1 !important;
            transform: translateX(0) rotateY(0deg) !important;
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(45px) scale(0.97);
            transition: all 0.5s ease-out 0.7s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(40px) scale(0.98);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
        }
        @media (max-width: 767px) {
        
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.1s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.2s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.3s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.4s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.5s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.6s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.7s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
        }
        .btn {
          transition: all 0.3s ease;
          transform: translateY(0);
        }
        .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(226, 114, 57, 0.4);
        }
        .services-hover-effect {
          transition: all 0.3s ease;
        }
        .services-hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }
      `}</style>
      <section className="hero-section text-center">
        <div
          className={`about_bg  d-md-flex d-none align-items-center justify-content-center add_extra_width animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >

          <div className="row mx-auto mt-5 pt-5">
            <div className="col-12 text-center ">
              <h1 className="about_font text-white fw-bold" >
                Streamlined Medical Accounts Receivable Services<br />  for a Stronger Revenue Cycle
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                Efficient medical accounts receivable keeps finances healthy. Our tailored AR
                <br /> solutions and expert support speed up collections and reduce delays.
              </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={handleShow} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>
          </div>
        </div>

        <div
          className={` add_ng_mobile_img d-md-none d-block align-items-start mt-5 pt-5 justify-content-center add_extra_width animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >

          <div className="row mx-auto ">
            <div className="col-12 text-center ">
              <h1 className="about_font text-white fw-bold" >
                Streamlined Medical Accounts Receivable Services<br />  for a Stronger Revenue Cycle
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                Efficient medical accounts receivable keeps finances healthy. Our tailored AR
                <br /> solutions and expert support speed up collections and reduce delays.
              </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-5 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={handleShow} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>
          </div>
        </div>
        {/* <div 
        className={`container add_box_shadow_rounded bg-white animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[1] = el}
        data-section-index="1"
      >
        <div className='row mx-auto py-md-5 py-3'>
          <div className='col-12 add_border_bottom pb-md-4 pb-3 text-start px-0'>
            <h3 className='mb-0 add_driving_font fw-semibold text-center'>
              Accounts Receivable <span className='add_grident_font'> Expertise</span>
            </h3>
          </div>
          <div className='col-12'>
            <div className='row'>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-4 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      15+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-3 mb-md-0'>
                      Years of Experience
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-4 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      2000+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-md-0 mb-3'>
                      Team Members
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-md-4 pt-0 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      $2.7B+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-0'>
                      In Payments
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-md-4 pt-0 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      $20B+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-0'>
                      In Charges
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}


        <div
          className={`boost_main_clie position-relative animate-section ${animatedSections.has(2) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[2] = el}
          data-section-index="2"
        >

          <div className='container pt-lg-4'>
            <div className='row py-md-5 py-4 mx-auto'>
              <div className='col-12 d-flex align-items-center text-center pe-0 justify-content-center'>
                <h2 className='mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold'>
                  Medical Accounts Receivable: Optimized for Growth
                </h2>
              </div>
              <div className='col-12 mt-md-5 mt-0'>
                <div className='row mt-md-4 mt-0'>
                  <div className='col-lg-6 mt-4'>
                    <div className='row'>
                      <div className="col-md-2 col-12 text-center text-md-start mt-2 pe-md-0 pe-2 mb-2 mb-md-0">
                        <img src={one} alt='certified provider credentialing specialist' style={{ width: "3rem", height: "3rem", objectFit: "contain" }} />
                      </div>
                      <div className='col-lg-10 ps-0'>
                        <div className='row'>


                          <div className='col-12 d-flex align-items-start text-md-start text-center pe-0 justify-content-md-start justify-content-center mb-2 mb-md-0'>
                            <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text'>
                              Maximizing Collections with Precision                                     </h3>
                          </div>
                          <div className='col-12 d-flex align-items-start justify-content-md-start justify-content-center mt-md-3 mb-md-3'>
                            <p className='mb-0 d-flex align-items-start justify-content-md-start justify-content-center text-md-start text-center add_small_font_text'>
                              We manage every stage of your AR process to secure faster payments, reduce claim aging, and minimize denials. Our focused approach ensures steady cash flow and consistent revenue.
                            </p>
                          </div>


                        </div>
                      </div>
                    </div>

                  </div>


                  <div className='col-lg-6 mt-3 mt-md-0'>
                    <div className='row mx-auto'>
                      <div className='col-12'>
                        <img src={oneright} alt='certified provider credentialing specialist' className='twogroup_imgs' />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className='col-12 mt-md-5 mt-3'>
                <div className='row'>
                  <div className='col-lg-6 d-md-block d-none'>
                    <div className='row mx-auto'>
                      <div className='col-12'>
                        <img src={twoleft} alt='Provider Enrollment' className='twogroup_imgs' />
                      </div>
                    </div>

                  </div>
                  <div className='col-lg-6 mt-md-4 mt-0'>
                    <div className='row'>
                      <div className="col-md-2 col-12 text-center text-md-start mt-2 pe-md-0 pe-2 mb-2 mb-md-0">
                        <img src={two} alt='Provider Enrollment' style={{ width: "3rem", height: "3rem", objectFit: 'contain' }} />
                      </div>
                      <div className='col-lg-10 ps-0'>
                        <div className='row'>


                          <div className='col-12 d-flex align-items-start text-md-start text-center pe-0 justify-content-md-start justify-content-center mb-2 mb-md-0'>
                            <h3 className='mb-0 d-flex align-items-center justify-content-md-start justify-content-center fw-semibold add_subheading_font_text'>
                              Strengthening Your Revenue Cycle                                     </h3>
                          </div>
                          <div className='col-12 d-flex align-items-start justify-content-md-start justify-content-center mt-md-3 mb-md-3'>
                            <p className='mb-0 d-flex align-items-start justify-content-md-start justify-content-center text-md-start text-center add_small_font_text'>
                              Through tailored strategies and proactive follow-up, we streamline workflows, resolve outstanding claims, and enhance overall revenue cycle performance for long-term growth.
                            </p>
                          </div>


                        </div>
                      </div>
                    </div>

                  </div>



                </div>
              </div>


            </div>
          </div>
          <div className='boost_main_client boost_main_client_two position-absolute'>
            <img src={clients} alt='' />
          </div>
        </div>

        <div
          className={`container py-lg-5 py-4 px-2 px-md-5 change_radius mx-auto d-flex align-items-center justify-content-center my-md-5 mt-md-4 my-0 position-relative animate-section ${animatedSections.has(3) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[3] = el}
          data-section-index="3"
          style={{ background: "#2A3040", borderBottom: "15px solid #9CB5FF", zIndex: "999" }}
        >
          {/* <img src={mentalhealth} alt='' className='position-absolute boost_main_client_mental' /> */}
          <div className='row mx-auto'>
            <div className='col-12 d-flex align-items-center text-center pe-0 justify-content-center mb-md-5 mb-3'>
              <h2 className='mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold text-white'>
                Elevating Medical Accounts Receivable to the Next Level
              </h2>
            </div>
            <div className='col-12 '>
              <div className='row border-bottom-gray pb-4 mx-auto'>
                <div className='col-6 ps-0'>
                  <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                    Smart AR Management for Faster Payments                                    </h3>                      </div>
                <div className='col-6 pe-0'>
                  <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">Every delayed claim slows down your cash flow. We track accounts with precision, follow up relentlessly, and recover overdue payments so you get paid on time without the headaches.  </p>
                </div>
              </div>
            </div>
            <div className='col-12 '>
              <div className='row border-bottom-gray py-md-4 py-2 mx-auto'>
                <div className='col-6 ps-0'>
                  <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                    Revenue Cycle Strategies That Actually Work                                    </h3>                      </div>
                <div className='col-6 pe-0'>
                  <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">We go beyond surface-level fixes. By targeting the real bottlenecks, denials, underpayments, and slow payers we keep your revenue cycle moving smoothly and predictably.  </p>
                </div>
              </div>
            </div>
            <div className='col-12 '>
              <div className='row border-bottom-gray py-md-4 py-2 mx-auto'>
                <div className='col-6 ps-0'>
                  <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                    Solutions Built Around Your Practice                                   </h3>                      </div>
                <div className='col-6 pe-0'>
                  <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">No two practices are the same. Whether you’re a single-provider clinic or a multi-specialty group, we design AR workflows that fit your setup, ensuring accuracy and steady collections month after month.  </p>
                </div>
              </div>
            </div>
            <div className='col-12 '>
              <div className='row pt-4 mx-auto'>
                <div className='col-6 ps-0'>
                  <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                    A True Growth Partner                                    </h3>                      </div>
                <div className='col-6 pe-0'>
                  <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">We don’t just chase claims we partner with you. With transparent reporting and a dedicated AR team, you gain the clarity, control, and confidence to focus on care while we safeguard your revenue. </p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div
          className={`section_data position-relative animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[4] = el}
          data-section-index="4"
        >
          <div class="boost_main_client boost_main_client_two_sets position-absolute"><img src={clients} alt="" /></div>
          <div className="container px-0 px-md-0 pb-md-5 py-4 pt-md-4">
            <div className="row justify-content-center mx-auto">

              <div className='col-12 d-flex align-items-center justify-content-center'>
                <h2 className='mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold text-center'>
                  Comprehensive Medical AR Support Powering Healthcare Excellence
                </h2>
              </div>

              <div className="col-12 mt-md-4 mt-2 px-1 px-md-0">
                <div className="row mx-auto">
                  {services.map((service, index) => (
                    <div
                      key={index}
                      className="col-6 col-sm-12 col-md-3 position-relative mb-md-0 mb-0 p-2"
                    >
                      <div className="row h-100 mx-auto">
                        <div
                          className="col py-md-5 py-3 px-md-2 px-0 border services-hover-effect"
                          style={{ borderRadius: "21px", cursor: 'pointer' }}
                          onClick={() => handleServiceClick(service.title)}
                        >
                          <div className="row mx-auto">
                            <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-0 text-start text-md-start">
                              <img
                                src={service.icon}
                                alt={service.alt}
                                loading="lazy"
                                className="mb-2 mb-md-0"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "contain",
                                }}
                              />

                            </div>
                            <div className='col-12 text-start mb-md-3 mb-2 '>
                              <h3 className="add_font_another mb-0 fw-semibold text-start">
                                {service.title}
                              </h3>
                            </div>
                            <div className="col-12 text-start">
                              <p className="mb-0 add_font_card_para_data">
                                {service.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <img
                        src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                        alt=""
                        className="add_position_card_img position-absolute"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <section
          className={`py-lg-5 pb-0 px-0 px-md-5 add_border_radius_second animate-section mt-md-4 mt-0 ${animatedSections.has(5) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[5] = el}
          data-section-index="5"
          style={{ background: "#EFF3FF" }}
        >
          <Container>
            <Row className="align-items-center py-lg-4">
              <Col lg={6} className="d-flex gap-3 justify-content-center flex-wrap px-lg-5">

                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center">
                  <h2 className='text-black contact-text  m-0 mt-lg-0 mt-4'>
                    End-to-End AR Solutions for Healthcare Providers
                  </h2>
                  <p className='any-para mt-3 mt-lg-4 mb-md-0 mb-3'>
                    With{" "}
                    <a
                      href="https://probillrcm.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                    >
                      ProBill RCM
                    </a>
                    , healthcare providers gain a partner in revenue cycle optimization, ensuring smoother cash flow, fewer delays, and efficient financial operations.
                  </p>                </div>
              </Col>
              <Col lg={6} className=" pe-lg-6 bg-white px-3 py-4" style={{ borderRadius: "12px" }}>
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item border-bottom border-0">
                    <h3 class="accordion-header" id="headingOne">
                      <button class="accordion-button add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Claim Submission & Tracking
                        <span class="accordion-icon ms-auto">
                          <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div class="accordion-body add_custom_font_para px-0">
                        We prepare and submit claims with complete accuracy, then track them through every stage until payment is received. This minimizes delays and ensures faster reimbursements from payers.                                    </div>
                    </div>
                  </div>
                  <div class="accordion-item border-bottom border-0">
                    <h3 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Patient Billing & Collections
                        <span class="accordion-icon ms-auto">
                          <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div class="accordion-body add_custom_font_para px-0">
                        We handle patient statements, reminders, and payment follow-ups with professionalism, improving collection rates while maintaining positive patient relationships.  </div>
                    </div>
                  </div>
                  <div class="accordion-item border-bottom border-0">
                    <h3 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Reporting & Analytics
                        <span class="accordion-icon ms-auto">
                          <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div class="accordion-body add_custom_font_para px-0">
                        Our detailed AR reports provide actionable insights, helping you identify trends, address bottlenecks, and make informed financial decisions.              </div>
                    </div>
                  </div>

                  <div class="accordion-item border-0">
                    <h3 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Compliance & Accuracy
                        <span class="accordion-icon ms-auto">
                          <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                      <div class="accordion-body add_custom_font_para px-0">
                        We ensure all AR activities meet healthcare regulations, keeping your billing accurate, compliant, and audit-ready at all times.                </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section
          className={`pb-md-0 pb-0 px-0 px-md-5 position-relative animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[6] = el}
          data-section-index="6"
        >
          <div className='boost_main_client boost_main_client_two_sets position-absolute'>
            <img src={clients} alt='' />
          </div>
          <div class="boost_main_client boost_main_client_tranform_first_data position-absolute"><img src={clients} alt="" /></div>

          <div className="container px-0 px-md-0 py-md-5 py-0">
            <div className="row justify-content-center mx-auto py-lg-4">


              <div className='col-12 d-flex flex-column align-items-center justify-content-start'>
                <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold'>
                  What Sets Us Apart

                </h2>
                <p className="mb-0 text-dark add_para_font fw-medium text-center text-md-start">
                  <a
                    href="https://probillrcm.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                  >
                    ProBill RCM
                  </a>{" "}
                  combines industry expertise, advanced technology, and personalized support to deliver seamless AR solutions
                  <br />
                  that boost efficiency and accelerate revenue for healthcare providers.
                </p>              </div>

              <div className="col-12 mt-md-4 mt-2 px-1 px-md-0">
                <div className="row mx-auto">
                  {familyMedicineServices.map((service, index) => (
                    <div
                      key={index}
                      className="col-6 col-sm-12 col-md-4 position-relative mb-md-0 mb-0 p-2"
                    >
                      <div className="row h-100 mx-auto">
                        <div
                          className="col py-md-4 py-3 px-md-3 px-0 services-hover-effect-data bg-white add_border_bottom_sets"
                          onClick={() => handleServiceClick(service.title)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="row mx-auto">
                            <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-0 text-start text-md-start">
                              <img
                                src={service.icon}
                                alt={service.alt}
                                loading="lazy"
                                className="mb-2 mb-md-0"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "contain"
                                }}
                              />
                            </div>
                            <div className="col-12 text-start mb-md-3 mb-2">
                              <h3 className="add_top_heading_content mb-0 ms-md-0 ms-0 fw-semibold">
                                {service.title}
                              </h3>
                            </div>
                            <div className="col-12 text-start">
                              <p className="mb-0 add_font_card_para_data">
                                {service.description}
                              </p>
                            </div>
                            {/* <div className="col-12 text-end">
                            <p className="mb-0 add_font_card_para_data d-flex align-items-center justify-content-end add_grident_font fw-bold">
                              Learn More <i className="bi bi-arrow-right-short fs-3 ms-1"></i>
                            </p>
                          </div> */}

                          </div>
                        </div>
                      </div>
                      <img
                        src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                        alt=""
                        className="add_position_card_img position-absolute"
                        loading="lazy"
                      />
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
        </section>


        <div
          className={`container about_bg_blue mb-md-5 mb-4 mt-4 mt-md-0 animate-section visible py-4 py-md-4 animate-section ${animatedSections.has(7) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[7] = el}
          data-section-index="7"
          style={{ borderRadius: "36px" }}
        >
          <div className="row mx-auto mt-0 mt-lg-0 py-md-5 py-0">
            <div className="col-lg-9 mx-auto m-0 col-12  mt-md-0 mt-0 pb-3 text-lg-center flex-column d-flex justify-content-center">
              <h2 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-md-block d-none'>
                Your Partner in Streamlining Medical<br /> Accounts Receivable
              </h2>
              <h3 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-block d-md-none'>
                Your Partner in Streamlining Medical Accounts Receivable
              </h3>
              <p className=' any-para mt-3 mt-lg-4 mb-0' style={{ color: 'rgba(255, 255, 255, 1)' }}>Struggling with medical accounts receivable can slow your cash flow and cut into profits. That’s where we come in our seasoned AR specialists pinpoint the problems, remove roadblocks, and get your revenue cycle running at full speed. With our in-depth AR analysis, we often uncover hidden income that can give your bottom line a powerful boost.
              </p>


            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={() => { handleCTAClick('bottom_section'); handleShow(); }} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
        <PopularArticles />
      </section>

      <Modal show={showModal} onHide={handleClose} centered size='xl'>
        {/* Close Button in Top-Right Corner */}
        <button
          type="button"
          className="btn-close position-absolute"
          style={{
            top: "11px",
            right: "11px",
            zIndex: 1051,
            backgroundColor: "#fff",
            borderRadius: "50%",
            padding: "6px",
            fontSize: "15px",
            // border:"2px solid black",
          }}
          aria-label="Close"
          onClick={handleClose}
        ></button>

        <Modal.Body className="p-4">
          <div className="container-fluid">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="image-container">
                  <img
                    src={external1}
                    alt="Team Working"
                    className="w-100 h-100 diagonal-image"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                {isSubmitted ? (
                  <div className="text-center">
                    <h1 className="hero-text mt-0">
                      Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                    </h1>
                    <p>for submitting your information! Our representative will reach out to you shortly.</p>
                  </div>
                ) : (
                  <>
                    <div className="d-flex m-0 modal-heading justify-content-between">
                      <h1>
                        How can we <span style={{ color: "#E27239" }}>help you?</span>
                      </h1>
                      {/* Remove this old close button if not needed */}
                      {/* <button
                                          type="button"
                                          className="btn-close d-lg-none d-block"
                                          onClick={handleClose}
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                      ></button> */}
                    </div>
                    <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                      Within 24 hours, a representative from our company will contact you.
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Name</label>
                          <input
                            type="text"
                            placeholder="Enter your Full Name"
                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("fullName", { required: "Full Name is required" })}
                          />
                          {errors.fullName && (
                            <p className="text-danger">{errors.fullName.message}</p>
                          )}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Email</label>
                          <input
                            type="email"
                            placeholder="Enter your Email"
                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                message: "Please enter a valid email address"
                              }
                            })}
                          />
                          {errors.email && (
                            <p className="text-danger">{errors.email.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Subject</label>
                          <input
                            type="text"
                            placeholder="Enter Subject"
                            className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("subject", {
                              required: "Subject is required",
                              minLength: {
                                value: 3,
                                message: "Subject should be at least 3 characters long"
                              }
                            })}
                          />
                          {errors.subject && (
                            <p className="text-danger">{errors.subject.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Message</label>
                          <textarea
                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480" }}
                            rows="7"
                            placeholder="Brief us on your requirements"
                            {...register("message", {
                              required: "Message is required",
                              minLength: {
                                value: 10,
                                message: "Message should be at least 10 characters long"
                              }
                            })}
                          ></textarea>
                          {errors.message && (
                            <p className="text-danger">{errors.message.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mt-3">
                          <button
                            type="submit"
                            className="btn col-12"
                            style={{
                              background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                              color: "white",
                              borderRadius: "12px",
                              padding: "12px 24px",
                              border: "none",
                              fontWeight: "500",
                              fontSize: "16px"
                            }}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "SENDING..." : "Submit Now"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AccountsReceivable;
